export const build = { date:"2026-05-26.1649", stage:"alpha" }
